module.exports = __webpack_public_path__ + "static/media/plate.d5eb3345.png";